import { createTheme, ThemeProvider } from "@mui/material/styles";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import rtlPlugin from "stylis-plugin-rtl";
import { prefixer } from "stylis";

const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

export default function MUITheme(props) {
  const light = createTheme({
    direction: "rtl",

    typography: {
      fontFamily: "iranYekan, sans-serif",
    },

    spacing: 8, // 8px for spacing

    palette: {
      primary: {
        main: "#00c19f",
        contrastText: "#fff",
      },
      secondary: {
        main: "#135287",
        contrastText: "#fff",
      },
      info: {
        main: "#17a2b8",
        contrastText: "#fff",
      },
      warning: {
        main: "#f2a921",
        contrastText: "#fff",
      },
      background: {
        default: "#cce3eb",
        contrastText: "#fff",
      },
      status_gray: {
        main: "#cccccc",
        contrastText: "#fff",
      },
      status_green: {
        main: "#00c19f",
        contrastText: "#fff",
      },
      status_blue: {
        main: "#4597FF",
        contrastText: "#fff",
      },
      status_orange: {
        main: "#ff9900",
        contrastText: "#fff",
      },
      status_yellow: {
        main: "#F8E913",
        contrastText: "#fff",
      },
      status_red: {
        main: "#FD4F4F",
        contrastText: "#fff",
      },

      text: {
        primary: "#606060",
        warning: "#f2a921",
        first: "#00c19f",
        second: "#135287",
      },

      ...props.theme,
    },

    shadows: [
      "none",
      "0px 1px 5px 0px hsla(0,0%,0%,0.25)",
      "0px 2px 5px 0px hsla(0,0%,0%,0.25)",
      "0px 3px 5px 0px hsla(0,0%,0%,0.25)",
      "0px 4px 10px 0px hsla(0,0%,0%,0.35)",
      ...Array(20).fill("0px 4px 10px 0px hsla(0,0%,0%,0.30)"),
    ],

    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            minWidth: "auto",
          },
        },
      },
      MuiFormControlLabel: {
        styleOverrides: {
          root: {
            margin: "0",
          },
        },
      },
      MuiInputLabel: {
        styleOverrides: {
          root: {
            color: "inherit",
          },
        },
      },
      MuiLink: {
        styleOverrides: {
          root: {
            textDecoration: "none",
          },
        },
      },
      MuiPaper: {
        defaultProps: {
          elevation: "0",
        },
      },
      MuiCircularProgress: {
        defaultProps: {
          size: 30,
        },
        styleOverrides: {
          root: {
            color: "#333",
          },
        },
      },
      MuiSelect: {
        defaultProps: {
          color: "secondary",
        },
      },
      MuiTextField: {
        defaultProps: {
          color: "secondary",
        },
      },
    },
  });
  const dark = createTheme({
    direction: "rtl",

    typography: {
      fontFamily: "iranYekan, sans-serif",
    },

    spacing: 8, // 8px for spacing

    palette: {
      mode: "dark",

      primary: {
        main: "#ff0000",
        contrastText: "#fff",
      },
      secondary: {
        main: "#c60000",
        contrastText: "#fff",
      },
      info: {
        main: "#ff3030",
        contrastText: "#fff",
      },
      warning: {
        main: "#f2a921",
        contrastText: "#fff",
      },
      background: {
        default: "#000",
        paper: "#222",
      },
      text: {
        primary: "#f2f2f2",
        secondary: "#606060",
        warning: "#f2a921",
        first: "#b50000",
        second: "#135287",
      },

      ...props.theme,
    },

    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            minWidth: "auto",
          },
        },
      },
      MuiFormControlLabel: {
        styleOverrides: {
          root: {
            margin: "0",
          },
        },
      },
      MuiInputLabel: {
        styleOverrides: {
          root: {
            color: "inherit",
          },
        },
      },
      MuiLink: {
        styleOverrides: {
          root: {
            textDecoration: "none",
          },
        },
      },
      MuiPaper: {
        defaultProps: {
          elevation: "0",
        },
      },
      MuiCircularProgress: {
        defaultProps: {
          size: 30,
        },
      },
      MuiSelect: {
        defaultProps: {
          color: "secondary",
        },
      },
      MuiTextField: {
        defaultProps: {
          color: "secondary",
        },
      },
    },
  });

  return (
    <CacheProvider value={cacheRtl}>
      <ThemeProvider theme={light}>{props.children}</ThemeProvider>
    </CacheProvider>
  );
}
